import React, { ReactNode, JSX } from 'react'
import styles from './Tooltip.module.scss'

export const TooltipView = (props: { text: string, style: object, children: ReactNode }): JSX.Element => {
  const {
    text,
    style,
    children
  } = props

  return (
    <span className={styles._box} style={style}>
      {children}

      {!!text && (
        <span className={styles._popup}>
          <span className={styles._text} dangerouslySetInnerHTML={{ __html: text }}></span>
        </span>
      )}
    </span>
  )
}
